<mat-toolbar class="matero-toolbar" role="banner">
  <button mat-icon-button class="matero-toolbar-button" aria-label="open sidebar menu" name="open sidebar menu"
    *ngIf="(!environment.collapsibleSidebar || sharedService.mobile) && environment.displaySidebar && isAuthenticated()"
    (click)="toggleSidenav.emit()">
    <mat-icon>menu</mat-icon>
  </button>

  <a class="portal-home" [routerLink]="isAuthenticated() ? '/dashboard' : '/welcome'">
    <span class="portal-logo">
      <img src="assets/images/OHA-Color.png" width="1500" height="495" alt="Oregon Health Authority">
    </span>
    <span class="portal-brand">{{ sharedService.mobile ? titleMobile : titleFull }}</span>
    <span class="visually-hidden"> — portal home</span>
  </a>

  <app-translate *ngIf="environment.translateText"></app-translate>

  <div class="portal-account">
    <button *ngIf="environment.showThemeToggle" mat-icon-button
      [matMenuTriggerFor]="themeMenu" aria-label="Choose color theme" matTooltip="Choose color theme">
      <mat-icon>palette</mat-icon>
    </button>
    <mat-menu #themeMenu="matMenu" class="portal-theme-menu" aria-label="Color theme">
      <div class="portal-theme-columns">
      <div *ngFor="let column of themeColumns; let c = index" class="portal-theme-column" role="group" [attr.aria-label]="column.label + ' themes'">
      <div class="portal-theme-column-title" aria-hidden="true">{{ column.label }}</div>
      <button *ngFor="let theme of column.themes; let r = index" #themeOption="matMenuItem" mat-menu-item role="menuitemradio" class="portal-theme-option"
        [attr.aria-label]="theme.label + ', ' + column.label + ' theme'"
        [attr.aria-checked]="sharedService.theme === theme.id"
        (keydown)="navigateTheme($event, c, r)"
        (click)="selectTheme(theme.id)">
        <span class="portal-theme-choice">
          <span class="portal-theme-sphere" [style.background-image]="theme.swatch" aria-hidden="true"></span>
          <span class="portal-theme-label">{{ theme.label }}</span>
          <mat-icon class="portal-theme-check" aria-hidden="true">check</mat-icon>
        </span>
      </button>
      </div>
      </div>
    </mat-menu>
    <button mat-icon-button *ngIf="!isAuthenticated()" (click)="login()" class="matero-toolbar-button"
      aria-label="Login" matTooltip="Login" matTooltipPosition="below" [matTooltipShowDelay]="750">
      <mat-icon class="dark-theme-icon">login</mat-icon>
    </button>


    <div *ngIf="isAuthenticated()" class="flex flex-row justify-start items-center m-r-8">
      <button mat-button [matMenuTriggerFor]="userMenu"><span class="portal-username">{{ username }}</span>
        <mat-icon>expand_more</mat-icon>
      </button>
    </div>

     <mat-menu #userMenu="matMenu">
      <button mat-menu-item *ngIf="isAuthenticated()" routerLink='/account-information' class="matero-toolbar-button"
      aria-label="Account Information" matTooltip="Account Information" matTooltipPosition="below" [matTooltipShowDelay]="750">
      <span class="m-r-16">Account</span>
      <mat-icon>account_circle</mat-icon>
      </button>
      <button mat-menu-item *ngIf="isAuthenticated()" (click)="logout()" class="matero-toolbar-button"
        aria-label="Logout" matTooltip="Logout" matTooltipPosition="below" [matTooltipShowDelay]="750">
        <span class="m-r-16">Sign-Out</span>
        <mat-icon>logout</mat-icon>
      </button>

    </mat-menu>
  </div>
</mat-toolbar>
